<template>
  <div class="col-lg-12 col-xl-12 stretch-card">
    <div class="card">
      <div class="card-header">
        <h4 style="margin-right: 5px" class="float-start" v-if="status != 'HISTORY'">Checklist P2H | STATUS: {{ status
          }}
        </h4>
        <h4 style="margin-right: 5px" class="float-start" v-if="status == 'HISTORY'">Checklist P2H | HISTORY</h4>


        <button v-if="permision_role.method_read" class="btn btn-success float-end btn-xs" style="margin-right: 5px"
          @click.prevent="downloadData()">
          <i class="link-icon" data-feather="download"></i>
          {{ $t("downloadData") }} .xlsx
        </button>
      </div>

      <div class="card-body">
        <div class="table-responsive" style="overflow-y: auto;">
          <div class="col-sm-12">

            <vue-good-table title="list-order-ct" ref="list-order-ct" mode="remote" :select-options="{
              enabled: false,
              selectOnCheckboxOnly: false,
              selectionText: $t('data_selected'),
              clearSelectionText: $t('clear'),
            }" @on-page-change="onPageChange" @on-sort-change="onSortChange" @on-column-filter="onColumnFilter"
              @on-per-page-change="onPerPageChange" :totalRows="totalRecords" :line-numbers="true"
              :isLoading.sync="isLoading" :pagination-options="{
                enabled: true,
              }" :rows="rows" :columns="status == 'HISTORY' ? columnsHistory : columns">

              <div slot="selected-row-actions">


              </div>



              <template slot="table-row" slot-scope="props">


                <span v-if="props.column.field == 'actions' && status !== 'HISTORY'">


                  <a style="color: #ab0635;text-decoration: none; cursor: pointer;"
                    v-if="permision_role.method_update && props.row.p2h_checklist_result != 'VALID'" title="Edit "
                    @click.prevent="
                      editData(props.row)
                      ">
                    <i class="mdi mdi-square-edit-outline" style="font-size:16px"></i>

                  </a>
                  <a style="color: #ab0635;text-decoration: none; cursor: pointer;" v-if="permision_role.method_read"
                    title="Detail" @click.prevent="
                      detailData(props.row)
                      ">
                    <i class="mdi mdi-eye" style="font-size:16px"></i>

                  </a>



                </span>


                <span v-if="props.column.field == 'actions' && status == 'HISTORY'">



                  <a class="mr-5" style="color: #ab0635;text-decoration: none; cursor: pointer;"
                    v-if="permision_role.method_read" title="Detail" @click.prevent="
                      detailHistory(props.row, 'no')
                      ">
                    <i class="mdi mdi-eye" style="font-size:16px"></i>

                  </a>


                  <a class="ml-5" style="color: #ab0635;text-decoration: none; cursor: pointer;"
                    v-if="permision_role.method_read" title="Detail LOG" @click.prevent="
                      detailHistory(props.row, 'yes')
                      ">
                    <i class="mdi mdi-eye-off" style="font-size:16px"></i>

                  </a>





                </span>


                <span v-else-if="props.column.field == 'payable_total'">
                  {{ formatNumber(props.row.payable_total) }}
                </span>







                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>

          </div>
        </div>


      </div>

    </div>

    <modal-approve-data :showModal="showModalApprove" :action="actions" :data="datas" @closeModal="closeMyModal"
      @refresh="loadItems()"></modal-approve-data>

    <modal-detail-history-p2h :showModal="showModalHistory" :data="datas" :log="log" @closeModal="closeMyModalHistory">

    </modal-detail-history-p2h>


  </div>





</template>

<script>
import moment from 'moment';
import ModalApproveChecklistP2H from "@/components/modal/modalApproveChecklistP2H.vue";
import ModaldetailHistoryP2h from "@/components/modal/modaldetailHistoryP2h.vue";

// import ModalRpa from "@/components/modal/modalRpa";

export default {
  name: "templateOrder",
  components: {
    "modal-approve-data": ModalApproveChecklistP2H,
    "modal-detail-history-p2h": ModaldetailHistoryP2h
  },
  props: {
    dateRange: { type: [Object, Array] },
    status: String
  },

  data() {
    return {
      actions: "",
      datas: "",
      log: "",
      showModalHistory: false,
      showModalApprove: false,
      maxToasts: 100,
      passData: [],
      ORDER_RESPONSE_TIME: 0,
      position: "up right",
      closeBtn: true,
      isLoading: false,
      errors: [],
      permision_role: [],
      transport_order_header_ids: [],
      langs: ["id", "en"],
      detailUser: [],
      changeOrderNoData: [],
      detailDivisi: [],
      totalRecords: 0,
      order_no_new: "",
      serverParams: {
        columnFilters: {},
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        per_page: 10,
      },
      columns: [

        {

          label: "Action",
          field: "actions",
          sortable: false,
        },


        {
          label: "P2H Status",
          field: "p2h_checklist_result",
          sortable: false,
          filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: ['VALID', 'INVALID'], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


        {
          label: "UJO Status",
          field: "p2h_approval",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: ['APPROVED', 'REJECTED'], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


        {
          label: "Accept Time",
          field: "accept_time",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: "", // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },




        {
          label: "Vehicle No",
          field: "vehicle_no",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: "Job External ID",
          field: "job_external",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: "Branch",
          field: "branch_name",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


        {
          label: "Payable",
          field: "payable_total",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


        {
          label: 'Type Truck',
          field: "type_truck",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By Type Truck", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: "NMK Driver",
          field: "driver_id",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // ipick_plannitial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Driver Name",
          field: "driver_name",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: "Load ID",
          field: "load_id",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: "ShipWithRef",
          field: "shipwith_ref",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },



        {
          label: 'Pick Plan',
          field: "pick_plan",

        },

        {
          label: "Pick Name",
          field: "pick_name",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


        {
          label: 'Dest Plan',
          field: "dest_plan",
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
          dateOutputFormat: 'dd MMM yyyy h:mm:ss a',//'dd MMM yyyy',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: "Dest Name",
          field: "dest_name",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },









      ],


      columnsHistory: [

        {

          label: "Action",
          field: "actions",
          sortable: false,
        },


        {
          label: 'Retake count',
          field: "retake_count",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },



        {
          label: 'P2H Name',
          field: "p2h_name",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


        {
          label: "Load ID",
          field: "load_id",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: 'Completed Date',
          field: "completed_date",
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
          dateOutputFormat: 'dd MMM yyyy h:mm:ss a',//'dd MMM yyyy',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


        {
          label: "NMK Driver",
          field: "nmk_driver",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // ipick_plannitial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Vehicle No",
          field: "vehicle_no",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


        {
          label: 'Type Truck',
          field: "type_truck",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By Type Truck", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },





      ],
      rows: [],
      rowsSelection: [],
      shipwith_ref_send: [],
    };
  },
  watch: {
    dateRange: {
      handler() {
        //console.log(newVal);
        this.loadItems();
      },

    },
  },
  computed: {

    // filteredColumns2() {
    //   // Tampilkan kolom `shipwithref` hanya jika session bernilai 1
    //   return this.columns.filter(column => {

    //     if (column.field === 'shipwith_ref' 
    //     || column.field === 'order_status'
    //     || column.field === 'status_tms'
    //     || column.field === 'transport_order_template.description'
    //             // && column.field !== 'transport_order_template.cubic'
    //             // && column.field !== 'auto_load'
    //             // && column.field !== 'carrier'
    //             // && column.field !== 'create_by'
    //             // && column.field !== 'actions'
    //             // && column.field !== 'request'

    //   ) {
    //       return this.detailUser.company_detail.code === 'BP' || this.detailUser.company_detail.code === 'LINC';
    //     }
    //     // Tampilkan kolom lain
    //     return true;

    //     // return column.field !== 'shipwith_ref' 
    //     //         // && column.field !== 'order_status' 
    //     //         // && column.field !== 'status_tms'
    //     //         // && column.field !== 'transport_order_template.description'
    //     //         // && column.field !== 'transport_order_template.cubic'
    //     //         // && column.field !== 'auto_load'
    //     //         // && column.field !== 'carrier'
    //     //         // && column.field !== 'create_by'
    //     //         // && column.field !== 'actions'
    //     //         // && column.field !== 'request'
    //     //       || (this.detailUser.company_detail.code == 'BP' || this.detailUser.company_detail.code == 'LINC');
    //   });
    // }

  },

  methods: {
    closeMyModal() {
      this.showModalApprove = false;
      this.loadItems();
    },


    closeMyModalHistory() {
      this.showModalHistory = false;
      //this.loadItems();
    },


    requestRescheduleder(row) {
      this.passData = row;
      this.passData.source = "CT";
      this.showModalRequestReschedule = true;
    },


    editData(row) {
      this.datas = "";
      this.showModalApprove = true;
      this.datas = row;
      this.actions = "Edit";
    },

    detailData(row) {
      this.datas = "";
      this.showModalApprove = true;
      this.datas = row;
      this.actions = "Detail";
    },


    checkSubmitDate(row) {
      const dateNow = this.$moment(new Date()).format("YYYY-MM-DD h:mm:ss");
      const dateData = this.$moment(row.submit_time).format("YYYY-MM-DD h:mm:ss");
      const dateDataPickup = this.$moment(row.pick_plan);
      const diff_in_millis = Math.abs(new Date(dateData) - new Date(dateNow))
      const diff_in_minutes = diff_in_millis / 60000
      const precentaceData = (diff_in_minutes * 100) / 25


      var hoursDataPickup = dateDataPickup.diff(dateNow, 'hours')
      if (hoursDataPickup > 48) {
        return "";
      } else {
        //console.log(diff_in_minutes);
        if (diff_in_minutes > this.ORDER_RESPONSE_TIME) {

          return {
            "background-color": "red",
            "color": "white"
          }

        } else if (precentaceData > 25) {
          return {
            "background-color": "yellow",
            "color": "black"
          }
        } else {
          return "";
        }

      }
    },


    selectedShifWithReff(ev) {
      this.shipwithref = ev;
      this.showModalAutoAccept = true;
    },

    clearSelection() {

      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataSend"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          // this.loadingSubmiting();
          this.fade(true);
          let data = {
            shipwith_ref: this.shipwith_ref_send
          }
          const baseURI =
            this.$settings.endPointCt + "planning/delete";
          this.$http
            .post(baseURI, data, { timeout: 200000 })
            .then((response) => {
              // this.loading();
              if (response.data.status == 200) {

                // response.data.datas.messages.forEach((item) => {
                //   this.success(item);
                // });
                this.success3(response.data.datas.messages);
                this.loadItems();
                this.isloading = false;
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            }).catch(error => {
              this.isLoading = false;
              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));
              } else {

                if (error.response) {
                  if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                  } else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                  } else if (error.response.status === 401) {
                    this.$router.push("/authorized-error");
                  } else {
                    this.$router.push('/page-not-found');
                  }
                }

              }

            });
        }
      });




    },
    editOrderNo(row) {
      this.changeOrderNoData = row;
      this.showModalChangeOrderno = true;
    },
    checkPickPlanDate(val) {
      const dateNow = this.$moment(new Date()).format("YYYY-MM-DD") + " 23:59:59";
      const dateData = this.$moment(val).format("YYYY-MM-DD") + " 23:59:59";
      if (new Date(dateData) < new Date(dateNow)) {

        return {
          "background-color": "red",
          "color": "white"
        }

      } else if (new Date(dateData) > new Date(dateNow)) {

        return ""

      } else {

        return {
          "background-color": "yellow",
          "color": "black"
        }

      }
    },
    rejectOrder(ev) {
      this.$refs['list-order-ct'].unselectAllInternal();
      this.transport_order_header_ids = [];
      this.transport_order_header_ids.push(ev.transport_order_header_id);
      this.showModalRejectData = true;
    },

    // selectedShifWithReff(ev){
    //   this.shipwithref=ev;
    //   this.showModalRpa=true;
    // },


    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      this.company_code = userDatas.sub.company_detail.code;
      // if (this.company_code === 'LINC' || this.company_code === 'BP') {
      //   this.selectOnCheckboxOnly = true;
      // } else {
      //   this.selectOnCheckboxOnly = false;
      // }


      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == 'ChecklistP2HController') {
          rolePermision = permision;
        }
      });

      if (!rolePermision.method_read) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;

      if (this.$route.query.msg) {
        if (this.$route.query.status == 200) {
          this.success(this.$route.query.msg)
        } else {
          this.error(this.$route.query.msg)
        }

      }

    },

    checkShipReff(id) {
      const baseURI =
        this.$settings.endPoint + "control-tower/transport-order-header/check-order-no-shipwithref/" + id;
      return this.$http
        .get(baseURI, {
          timeout: 200000
        }).then((response) => {
          this.countShipReff = response.data.datas;
          this.isLoading = false;
        }).catch(error => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {

            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 500) {
                this.$router.push('/server-error');
              } else if (error.response.status === 401) {
                this.$router.push("/authorized-error");
              } else {
                this.$router.push('/page-not-found');
              }
            }

          }

        });
    },

    async acceptOrder(row) {
      await this.checkShipReff(row.transport_order_header_id);

      var html = "";
      if (this.countShipReff.countData == 1) {
        html += "<p>You want to Accept Order ? </p><br>";
        html += "<p>Any Change Data ?</p>";
        html += "<p>Order Number Existing : <input class='form-control' value='" + row.order_no + "'  type='text' readonly><br>"
        html += "Order Number New  <input id='order_no_new' value='" + row.order_no + "' class='form-control' type='text'></p>"

      }
      var transport_order_header_ids = [];
      transport_order_header_ids.push(row.transport_order_header_id);
      this.$swal({
        title: this.$t("areYouSure"),
        text: "You want to Accept Order ?",
        html: html,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
        preConfirm: () => {
          if (this.countShipReff.countData == 1) {
            return [
              document.getElementById('order_no_new').value,
            ]
          }

        },
      })
        .then((result) => {
          if (result.value) {
            var formData = {
              transport_order_header_ids: transport_order_header_ids,
            };
            if (this.countShipReff.countData == 1) {
              formData.order_no_new = result.value[0];
            }
            const baseURI =
              this.$settings.endPoint + "control-tower/transport-order-header/accept"
            this.$http
              .post(baseURI, formData)
              .then((response) => {
                this.loading();
                this.loadItems();
                if (response.data.status === 200) {
                  this.success(response.data.datas.messages);

                } else {
                  this.errors = response.data.errors;
                  this.resultError(response.data.errors);
                }
              })
              .catch((error) => {
                this.loading();
                if (error.response) {
                  if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                  } else if (error.response.status === 500) {
                    this.$router.push("/server-error");
                  } else {
                    //this.$router.push("/page-not-found");
                  }
                }
              });
          }
        });
    },



    acceptMassOrder() {
      //await this.checkShipReff(row.transport_order_header_id);

      var html = "";

      this.$swal({
        title: this.$t("areYouSure"),
        text: "You want to All Accept Order ?",
        html: html,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",

      })
        .then((result) => {
          if (result.value) {
            var formData = {
              transport_order_header_ids: this.transport_order_header_ids,
            };
            // if(this.countShipReff.countData ==1){
            //   formData.order_no_new = result.value[0];
            // }
            const baseURI =
              this.$settings.endPoint + "control-tower/transport-order-header/accept"
            this.$http
              .post(baseURI, formData)
              .then((response) => {
                this.loading();
                this.loadItems();
                if (response.data.status === 200) {
                  this.success(response.data.datas.messages);

                } else {
                  this.errors = response.data.errors;
                  this.resultError(response.data.errors);
                }
              })
              .catch((error) => {
                this.loading();
                if (error.response) {
                  if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                  } else if (error.response.status === 500) {
                    this.$router.push("/server-error");
                  } else {
                    //this.$router.push("/page-not-found");
                  }
                }
              });
          }
        });
    },


    detailHistory(row, log) {
      this.log = log;
      this.showModalHistory = true;
      this.datas = row;
    },


    cancelOrder() {
      this.showModalRejectData = true;
    },

    priorityModal() {
      if (this.rowsSelection.length > 1) {
        this.$swal({
          icon: 'warning',
          backdrop: true,
          title: "Information",
          html: this.$t('txtpilihSatu'),
          showConfirmButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false
        })
      } else {
        this.showModalPriority = true;
      }

    },

    freePick() {


      if (this.rowsSelection.length > 1) {
        this.$swal({
          icon: 'warning',
          backdrop: true,
          title: "Information",
          html: this.$t('txtpilihSatu'),
          showConfirmButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false
        })
      } else {
        this.showModalFreePick = true;
      }
    },



    massfreePick() {


      if (this.rowsSelection.length == 1) {
        this.$swal({
          icon: 'warning',
          backdrop: true,
          title: "Information",
          html: 'Please select many order !',
          showConfirmButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false
        })
      } else {
        this.showModalFreePickMass = true;
      }
    },

    updateFormatDate(date) {
      let date_format = this.$moment(date).format("dd mmm yyyy");
      return date_format;
    },


    downloadData() {
      let dataSend = {
        start: moment(String(this.dateRange.startDate,)).format('YYYY-MM-DD'), //this.dateFilter.startDate,  // moment(String(this.forms.join_date)).format('YYYY-MM-DD');
        end: moment(String(this.dateRange.endDate,)).format('YYYY-MM-DD'),
      };

      var startDate = dataSend.start;
      var endDate = dataSend.end;
      var pick_plan = startDate + '~' + endDate;

      var dest_plan = '';
      if (this.serverParams.columnFilters.dest_plan != '') {
        dest_plan = this.$moment(this.serverParams.columnFilters.dest_plan).format("YYYY-MM-DD");
      }


      //let tanggal = this.filtertanggal.toISOString().split('T')[0]
      this.isLoading = true;

      var invalid_params = "";
      var baseURI = "";

      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name = "download_report_checklistp2h" + CurrentDate + ".xlsx";

      if (this.status == 'RETAKE') {
        invalid_params = "&retake=yes&download=download";
        baseURI = this.$settings.endPoint + `control-tower/transport-order-header/p2h-checklist?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&pick_plan=${pick_plan}&vehicle_no=${this.serverParams.columnFilters.vehicle_no}&dest_plan=${dest_plan}&pick_name=${this.serverParams.columnFilters.pick_name}&dest_name=${this.serverParams.columnFilters.dest_name}&type_truck=${this.serverParams.columnFilters.type_truck}&driver_id=${this.serverParams.columnFilters.driver_id}&driver_name=${this.serverParams.columnFilters.driver_name}&load_id=${this.serverParams.columnFilters.load_id}&shipwith_ref=${this.serverParams.columnFilters.shipwith_ref}&branch_name=${this.serverParams.columnFilters.branch_name}&payable_total=${this.serverParams.columnFilters.payable_total}&job_external=${this.serverParams.columnFilters.job_external}&accept_time=${this.serverParams.columnFilters.accept_time}&p2h_approval=${this.serverParams.columnFilters.p2h_approval}${invalid_params}`;

      } else if (this.status == 'NEW') {
        invalid_params = "&p2h_checklist_result=NEW&retake=&download=download";
        baseURI = this.$settings.endPoint + `control-tower/transport-order-header/p2h-checklist?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&pick_plan=${pick_plan}&vehicle_no=${this.serverParams.columnFilters.vehicle_no}&dest_plan=${dest_plan}&pick_name=${this.serverParams.columnFilters.pick_name}&dest_name=${this.serverParams.columnFilters.dest_name}&type_truck=${this.serverParams.columnFilters.type_truck}&driver_id=${this.serverParams.columnFilters.driver_id}&driver_name=${this.serverParams.columnFilters.driver_name}&load_id=${this.serverParams.columnFilters.load_id}&shipwith_ref=${this.serverParams.columnFilters.shipwith_ref}&branch_name=${this.serverParams.columnFilters.branch_name}&payable_total=${this.serverParams.columnFilters.payable_total}&job_external=${this.serverParams.columnFilters.job_external}&accept_time=${this.serverParams.columnFilters.accept_time}&p2h_approval=${this.serverParams.columnFilters.p2h_approval}${invalid_params}`;

      } else if (this.status == 'ACCEPT') {
        invalid_params = "&p2 invalid_params = `&completed_date=${pick_plan}`;h_checklist_result=NEW&download=download";
        baseURI = this.$settings.endPoint + `control-tower/transport-order-header/p2h-checklist-accept?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&pick_plan=${pick_plan}&vehicle_no=${this.serverParams.columnFilters.vehicle_no}&dest_plan=${dest_plan}&pick_name=${this.serverParams.columnFilters.pick_name}&dest_name=${this.serverParams.columnFilters.dest_name}&type_truck=${this.serverParams.columnFilters.type_truck}&driver_id=${this.serverParams.columnFilters.driver_id}&driver_name=${this.serverParams.columnFilters.driver_name}&load_id=${this.serverParams.columnFilters.load_id}&shipwith_ref=${this.serverParams.columnFilters.shipwith_ref}&branch_name=${this.serverParams.columnFilters.branch_name}&payable_total=${this.serverParams.columnFilters.payable_total}&job_external=${this.serverParams.columnFilters.job_external}&accept_time=${this.serverParams.columnFilters.accept_time}&p2h_approval=${this.serverParams.columnFilters.p2h_approval}${invalid_params}`;

      } else if (this.status == 'HISTORY') {
        invalid_params = `&completed_date=${pick_plan}&download=download`;
        baseURI = this.$settings.endPoint + `control-tower/transport-order-header/history-p2h-checklist?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&retake_count=${this.serverParams.columnFilters.retake_count}&p2h_name=${this.serverParams.columnFilters.p2h_name}&load_id=${this.serverParams.columnFilters.load_id}&nmk_driver=${this.serverParams.columnFilters.nmk_driver}&vehicle_no=${this.serverParams.columnFilters.vehicle_no}&type_truck=${this.serverParams.columnFilters.type_truck}${invalid_params}`;
       
      } else {
        invalid_params = "&p2h_checklist_result=" + this.status + '&retake=no&download=download';
        baseURI = this.$settings.endPoint + `control-tower/transport-order-header/p2h-checklist?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&pick_plan=${pick_plan}&vehicle_no=${this.serverParams.columnFilters.vehicle_no}&dest_plan=${dest_plan}&pick_name=${this.serverParams.columnFilters.pick_name}&dest_name=${this.serverParams.columnFilters.dest_name}&type_truck=${this.serverParams.columnFilters.type_truck}&driver_id=${this.serverParams.columnFilters.driver_id}&driver_name=${this.serverParams.columnFilters.driver_name}&load_id=${this.serverParams.columnFilters.load_id}&shipwith_ref=${this.serverParams.columnFilters.shipwith_ref}&branch_name=${this.serverParams.columnFilters.branch_name}&payable_total=${this.serverParams.columnFilters.payable_total}&job_external=${this.serverParams.columnFilters.job_external}&accept_time=${this.serverParams.columnFilters.accept_time}&p2h_approval=${this.serverParams.columnFilters.p2h_approval}${invalid_params}`;

      }
      

      //var columnFilters = this.serverParams.columnFilters;
      //{ timeout: 60000 },

      return this.$http
        .get(
          baseURI,
          {
            responseType: "blob",
            timeout: 60000
          }
        )
        .then((response) => {

          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        });
    },





    clickOrder(order) {
      this.$emit('show_order', order);


    },



    loadItems() {

      let dataSend = {
        start: moment(String(this.dateRange.startDate,)).format('YYYY-MM-DD'), //this.dateFilter.startDate,  // moment(String(this.forms.join_date)).format('YYYY-MM-DD');
        end: moment(String(this.dateRange.endDate,)).format('YYYY-MM-DD'),
      };

      var startDate = dataSend.start;
      var endDate = dataSend.end;
      var pick_plan = startDate + '~' + endDate;

      var dest_plan = '';
      if (this.serverParams.columnFilters.dest_plan != '') {
        dest_plan = this.$moment(this.serverParams.columnFilters.dest_plan).format("YYYY-MM-DD");
      }
      this.isLoading = true;
      var invalid_params = "";
      var baseURI = "";


      // TAB ACCEPT
      // p2h_checklist_result = NEW

      // TAB VALID
      // p2h_checklist_result = VALID
      // retake = NO

      // TAB INVALID
      // p2h_checklist_result = INVALID
      // retake = NO

      if (this.status == 'RETAKE') {
        invalid_params = "&retake=yes";
        baseURI = this.$settings.endPoint + `control-tower/transport-order-header/p2h-checklist?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&pick_plan=${pick_plan}&vehicle_no=${this.serverParams.columnFilters.vehicle_no}&dest_plan=${dest_plan}&pick_name=${this.serverParams.columnFilters.pick_name}&dest_name=${this.serverParams.columnFilters.dest_name}&type_truck=${this.serverParams.columnFilters.type_truck}&driver_id=${this.serverParams.columnFilters.driver_id}&driver_name=${this.serverParams.columnFilters.driver_name}&load_id=${this.serverParams.columnFilters.load_id}&shipwith_ref=${this.serverParams.columnFilters.shipwith_ref}&branch_name=${this.serverParams.columnFilters.branch_name}&payable_total=${this.serverParams.columnFilters.payable_total}&job_external=${this.serverParams.columnFilters.job_external}&accept_time=${this.serverParams.columnFilters.accept_time}&p2h_approval=${this.serverParams.columnFilters.p2h_approval}${invalid_params}`;

      } else if (this.status == 'NEW') {
        invalid_params = "&p2h_checklist_result=NEW&retake=";
        baseURI = this.$settings.endPoint + `control-tower/transport-order-header/p2h-checklist?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&pick_plan=${pick_plan}&vehicle_no=${this.serverParams.columnFilters.vehicle_no}&dest_plan=${dest_plan}&pick_name=${this.serverParams.columnFilters.pick_name}&dest_name=${this.serverParams.columnFilters.dest_name}&type_truck=${this.serverParams.columnFilters.type_truck}&driver_id=${this.serverParams.columnFilters.driver_id}&driver_name=${this.serverParams.columnFilters.driver_name}&load_id=${this.serverParams.columnFilters.load_id}&shipwith_ref=${this.serverParams.columnFilters.shipwith_ref}&branch_name=${this.serverParams.columnFilters.branch_name}&payable_total=${this.serverParams.columnFilters.payable_total}&job_external=${this.serverParams.columnFilters.job_external}&accept_time=${this.serverParams.columnFilters.accept_time}&p2h_approval=${this.serverParams.columnFilters.p2h_approval}${invalid_params}`;

      } else if (this.status == 'ACCEPT') {
        invalid_params = "&p2h_checklist_result=NEW";
        baseURI = this.$settings.endPoint + `control-tower/transport-order-header/p2h-checklist-accept?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&pick_plan=${pick_plan}&vehicle_no=${this.serverParams.columnFilters.vehicle_no}&dest_plan=${dest_plan}&pick_name=${this.serverParams.columnFilters.pick_name}&dest_name=${this.serverParams.columnFilters.dest_name}&type_truck=${this.serverParams.columnFilters.type_truck}&driver_id=${this.serverParams.columnFilters.driver_id}&driver_name=${this.serverParams.columnFilters.driver_name}&load_id=${this.serverParams.columnFilters.load_id}&shipwith_ref=${this.serverParams.columnFilters.shipwith_ref}&branch_name=${this.serverParams.columnFilters.branch_name}&payable_total=${this.serverParams.columnFilters.payable_total}&job_external=${this.serverParams.columnFilters.job_external}&accept_time=${this.serverParams.columnFilters.accept_time}&p2h_approval=${this.serverParams.columnFilters.p2h_approval}${invalid_params}`;

      } else if (this.status == 'HISTORY') {
        invalid_params = `&completed_date=${pick_plan}`;
        baseURI = this.$settings.endPoint + `control-tower/transport-order-header/history-p2h-checklist?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&retake_count=${this.serverParams.columnFilters.retake_count}&p2h_name=${this.serverParams.columnFilters.p2h_name}&load_id=${this.serverParams.columnFilters.load_id}&nmk_driver=${this.serverParams.columnFilters.nmk_driver}&vehicle_no=${this.serverParams.columnFilters.vehicle_no}&type_truck=${this.serverParams.columnFilters.type_truck}${invalid_params}`;

      } else {
        invalid_params = "&p2h_checklist_result=" + this.status + '&retake=no';
        baseURI = this.$settings.endPoint + `control-tower/transport-order-header/p2h-checklist?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&pick_plan=${pick_plan}&vehicle_no=${this.serverParams.columnFilters.vehicle_no}&dest_plan=${dest_plan}&pick_name=${this.serverParams.columnFilters.pick_name}&dest_name=${this.serverParams.columnFilters.dest_name}&type_truck=${this.serverParams.columnFilters.type_truck}&driver_id=${this.serverParams.columnFilters.driver_id}&driver_name=${this.serverParams.columnFilters.driver_name}&load_id=${this.serverParams.columnFilters.load_id}&shipwith_ref=${this.serverParams.columnFilters.shipwith_ref}&branch_name=${this.serverParams.columnFilters.branch_name}&payable_total=${this.serverParams.columnFilters.payable_total}&job_external=${this.serverParams.columnFilters.job_external}&accept_time=${this.serverParams.columnFilters.accept_time}&p2h_approval=${this.serverParams.columnFilters.p2h_approval}${invalid_params}`;

      }

      return this.$http
        .get(
          baseURI,
          // +
          // `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&company_name=${company_name}&transport_order_template_tonnage=${transport_order_template_tonnage}&transport_order_template_cubic=${transport_order_template_cubic}&transport_order_template_description=${transport_order_template_description}&order_status=${this.serverParams.columnFilters.order_status}&order_no=${this.serverParams.columnFilters.order_no}&postpone_time=${this.serverParams.columnFilters.postpone_time}&dest_name=${this.serverParams.columnFilters.dest_name}&order_date=${date_order}&pick_plan=${pick_plan}&dest_plan=${dest_plan}`,
          { timeout: 30000 }
        )
        .then((response) => {
          this.rows = response.data.datas.data;
          this.totalRecords = response.data.datas.total;
          if (this.status == '') {
            this.$emit('passDataNew', this.totalRecords);
          }

          if (this.status == 'ACCEPT') {
            this.$emit('passDataAccept', this.totalRecords);
          }

          if (this.status == 'VALID') {
            this.$emit('passDataValid', this.totalRecords);
          }

          if (this.status == 'INVALID') {
            this.$emit('passDataInValid', this.totalRecords);
          }

          if (this.status == 'RETAKE') {
            this.$emit('passDataRetake', this.totalRecords);
          }


          if (this.status == 'HISTORY') {
            //console.log('asdsadsadasd');
            //console.log(this.totalRecords);
            this.$emit('passDataHistory', this.totalRecords);
          }

          this.isLoading = false;
        }).catch(error => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {

            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 500) {
                //this.$router.push('/server-error');
              } else if (error.response.status === 401) {
                this.$router.push("/authorized-error");
              } else {
                this.$router.push('/page-not-found');
              }
            }

          }

        });
    },


    formatNumber(value) {
      //console.log(value);
      return parseInt(value).toLocaleString();
    },

    // load items is what brings back the rows from server

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      this.loadItems();
    },

    onColumnFilter(params) {
      params.page = 1;
      this.updateParams(params);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },

    onPerPageChange(params) {
      this.updateParams({ per_page: params.currentPerPage });
    },


    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    success2(msg) {
      let pesan = "";
      msg.forEach((item) => {
        pesan = pesan + "<p>* " + item + "</p>";
      });

      this.$swal({
        icon: 'info',
        backdrop: true,
        title: "Information",
        html: pesan,
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false
      })


    },


    success3(msg) {


      this.$swal({
        icon: 'info',
        backdrop: true,
        title: "Information",
        html: msg,
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false
      })


    },


    loadingSubmiting() {


      this.$swal({
        icon: 'warning',
        backdrop: true,
        title: "Please wait",
        html: '<h2>SUBMITTING ORDER...</h2>',
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })

    },


    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.isLoading = false;
      }, 1000); // hide the message after 3 seconds
    },


    logout() {
      this.$logoutUser();
      this.$router.push("/");
    },

    getSystemCode() {
      const baseURI = this.$settings.endPoint + "system-code/select?system_code=ORDER_RESPONSE_TIME";

      return this.$http
        .get(
          baseURI,
          { timeout: 200000 }
        )
        .then((response) => {
          var rows = response.data.datas.data;
          if (rows.length > 0) {
            this.ORDER_RESPONSE_TIME = rows[0].value;
          }

        }).catch(error => {

          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {

            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 500) {
                this.$router.push('/server-error');
              } else if (error.response.status === 401) {
                this.$router.push("/authorized-error");
              } else {
                this.$router.push('/page-not-found');
              }
            }

          }

        });
    },

  },
  events: {},

  mounted() {
    this.fetchIt();
    this.loading();
    this.getSystemCode();


  },
};
</script>